import { type FC } from 'react';

interface RadioTabProps {
    className?: string;
    children: React.ReactNode;
    cols?: '4' | '1-lg';
    fullWidth?: boolean;
}

const RadioTab: FC<RadioTabProps> = (props: RadioTabProps) => {
    const { children, className = '', cols = '4', fullWidth = false } = props;

    const classOutput = `radio-tab radio-tab-${fullWidth ? 'full-width' : 'auto'} cols-${cols} ${className}`;

    return (
        <div className={classOutput}>
            {children}
        </div>
    );
};

export default RadioTab;
